"use client"

import { EarlyAccessCard } from "./early-access-card"

// Account-scoped (see lib/client/seen-state.ts) — logged-out visitors fall
// back to these same names in localStorage since there's no account yet.
// Kept here (not moved into day-one-promo-stack.tsx) because
// founder-promo-modal.tsx still imports both — Founder's day-2+ gate reads
// this same "first visit" marker.
export const FIRST_SEEN_KEY = "meta:first_seen"
export const LOCAL_FIRST_SEEN_DATE_KEY = "goonru_first_seen_date"

/** Standalone wrapper used only by the admin content-preview panel
 * (components/admin/modal-content-manager.tsx). Real traffic only ever sees
 * EarlyAccessCard via day-one-promo-stack.tsx, which owns eligibility and
 * sequencing alongside Glymtober — this wrapper has no gating of its own,
 * it just shows the card immediately when forced open. */
export function EarlyAccessModal({ forceOpen = false, onClose }: { forceOpen?: boolean; onClose?: () => void } = {}) {
  if (!forceOpen) return null
  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/70 backdrop-blur-sm overflow-y-auto">
      <div className="relative w-full max-w-sm">
        <EarlyAccessCard onDone={() => onClose?.()} />
      </div>
    </div>
  )
}
